import {
  Box,
  Container,
  Grid,
  GridItem,
  Heading,
  Image,
  Link,
  List,
  ListItem,
  Text,
} from "@chakra-ui/react";
import Healthcare from "../img/healthcare.png";
import React from "react";
import { RightIcon } from "../components/Icons";
import {absoluteUrl} from "../components/Utils";
import {Helmet} from "react-helmet";

const ArticleTwo = () => {
  return (
      <>
        <Helmet>
          <title>Welltower Medical Office For Lease - Healthcare Real Estate Leasing Terms Simplified</title>
          <link rel="canonical" href={ absoluteUrl( "/healthcare-real-estate-terms-simplified")} />
        </Helmet>
    <Box mt={"91px"}>
      <Container maxW={{ md: "85%", base: "100%" }} pt={8}>
        <Image src={Healthcare} borderRadius={{ md: "30px", base: "12px" }} />
        <Grid
          mt={{ md: 20, base: 10 }}
          gap={{ md: 16, base: 4 }}
          gridTemplateColumns={"repeat(8,1fr)"}
        >
          <GridItem
            colSpan={{ md: 5, base: 8 }}
            px={{ md: 8, base: 2 }}
            pos={"relative"}
            _after={{
              content: { md: '""', base: "unset" },
              pos: "absolute",
              w: "1px",
              h: "100%",
              bgColor: "DarkTeal",
              right: "-5%",
              top: 0,
            }}
          >
            <Heading mb={10} color={"DarkBlue"}>
              Healthcare Real Estate Leasing Terms Simplified
            </Heading>
            <Text>
              Leasing healthcare real estate can be a complex process,
              especially when you encounter unfamiliar leasing terms and jargon.
              To help you navigate this world with confidence, we&#39;ve
              simplified and explained some of the essential leasing terms
              you&#39;re likely to encounter in healthcare real estate
              transactions.
            </Text>
            <List ms={{ md: 10, base: 6 }}>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Lessee:
                </Text>
                <List>
                  <ListItem>
                    Definition: A lessee is the tenant or renter, the party who
                    has a temporary interest in the lessor&#39;s asset through a
                    lease.
                  </ListItem>
                  <ListItem>
                    Simplified Explanation: You, as the tenant or renter of the
                    healthcare space.
                  </ListItem>
                </List>
              </ListItem>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Lessor:
                </Text>
                <List>
                  <ListItem>
                    Definition: The lessor is the landlord or owner of the
                    property who leases it to another person or entity.
                  </ListItem>
                  <ListItem>
                    Simplified Explanation: The property owner or landlord.
                  </ListItem>
                </List>
              </ListItem>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Shell Space:
                </Text>
                <List>
                  <ListItem>
                    Definition: Shell space refers to an interior area within a
                    building with basic features like floors, walls, windows,
                    and ceilings. It may include basic electrical, plumbing, and
                    HVAC.
                  </ListItem>
                  <ListItem>
                    Simplified Explanation: A space with the basic structure,
                    awaiting customization.
                  </ListItem>
                </List>
              </ListItem>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Tenant Improvement Allowance (TIA):
                </Text>
                <List>
                  <ListItem>
                    Definition: TIA is money provided by the landlord to the
                    tenant for making changes or improvements to the leased
                    space.
                  </ListItem>
                  <ListItem>
                    Simplified Explanation: Funds to customize the space to your
                    needs.
                  </ListItem>
                </List>
              </ListItem>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Usable Square Feet (USF):
                </Text>
                <List>
                  <ListItem>
                    Definition: USF is the total usable floor area of a room or
                    building, measured from outer surfaces to the center of
                    walls, windows, and interior walls.
                  </ListItem>
                  <ListItem>
                    Simplified Explanation: The space you can use for your
                    practice.
                  </ListItem>
                </List>
              </ListItem>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Rentable Square Feet (RSF):
                </Text>
                <List>
                  <ListItem>
                    Definition: RSF is USF plus the tenant&#39;s pro-rata share
                    of common building areas.
                  </ListItem>
                  <ListItem>
                    Simplified Explanation: The area for which you pay rent,
                    including shared spaces. needs.
                  </ListItem>
                </List>
              </ListItem>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Triple Net (NNN) Lease:
                </Text>
                <List>
                  <ListItem>
                    Definition: A lease where the tenant pays property taxes,
                    building insurance, maintenance costs, and other expenses in
                    addition to rent.
                  </ListItem>
                  <ListItem>
                    Simplified Explanation: You cover various property expenses
                    in addition to rent.
                  </ListItem>
                </List>
              </ListItem>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Gross Lease:
                </Text>
                <List>
                  <ListItem>
                    Definition: In a gross lease, the tenant pays a fixed rent
                    amount, and the landlord covers property taxes, insurance,
                    and maintenance costs.
                  </ListItem>
                  <ListItem>
                    Simplified Explanation: You pay a set rent without having to
                    pay the increase in operating expenses or receive the
                    benefit of a decrease in operating expenses.
                  </ListItem>
                </List>
              </ListItem>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Base Rent:
                </Text>
                <List>
                  <ListItem>
                    Definition: The set rental rate the tenant pays before
                    additional rent.
                  </ListItem>
                  <ListItem>
                    Simplified Explanation: The minimum rental amount owed for
                    your space.
                  </ListItem>
                </List>
              </ListItem>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Additional Rent:
                </Text>
                <List>
                  <ListItem>
                    Definition: Amount paid by the tenant for building operating
                    expenses or other charges.
                  </ListItem>
                  <ListItem>
                    Simplified Explanation: Costs to operate the facility, like
                    utilities, taxes, and janitorial services.
                  </ListItem>
                </List>
              </ListItem>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Rent Escalator:
                </Text>
                <List>
                  <ListItem>
                    Definition: A clause specifying how and when rent will
                    increase over time.
                  </ListItem>
                  <ListItem>
                    Simplified Explanation: How much and when your rent will go
                    up, typically on an annual basis.
                  </ListItem>
                </List>
              </ListItem>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Specified Use:
                </Text>
                <List>
                  <ListItem>
                    Definition: Use restrictions that define the permitted
                    activities or services within the leased space.
                  </ListItem>
                  <ListItem>
                    Simplified Explanation: Restrictions on what you can use the
                    space for.
                  </ListItem>
                </List>
              </ListItem>
            </List>
            <Text mt={6}>
              Understanding these key healthcare real estate leasing terms can
              empower you when navigating the leasing process. Whether
              you&#39;re the lessee or lessor, these simplified explanations
              ensure clarity and confidence in your healthcare real estate
              transactions.
            </Text>
            <Text fontStyle={"italic"} mt={6}>
              The information on this website is for informational purposes only
              and not for the purpose of providing legal advice.
            </Text>
          </GridItem>
          <GridItem colSpan={{ md: 3, base: 8 }} px={{ md: 8, base: 2 }}>
            <Box pos={"sticky"} top={20}>
              <Text color={"DarkTeal"} fontSize={"2xl"}>
                Other Articles
              </Text>
              <List color={"DarkBlue"}>
                <ListItem
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  borderBottom={"1px solid"}
                  borderColor={"#CED2D6"}
                  py={6}
                  px={4}
                  display={"flex"}
                >
                  <Link href="/what-is-mob">
                    <Text>
                      What is an MOB (Medical Office Building) and Why It
                      Matters in Healthcare?
                    </Text>
                  </Link>
                  <RightIcon />
                </ListItem>
                <ListItem
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  borderBottom={"1px solid"}
                  borderColor={"#CED2D6"}
                  py={6}
                  px={4}
                  display={"flex"}
                >
                  <Link href="/understanding-the-leasing-process">
                    <Text>
                      Understanding the Leasing Process: What to expect when
                      leasing a medical office space for your practice
                    </Text>
                  </Link>
                  <RightIcon />
                </ListItem>
                <ListItem
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  borderBottom={"1px solid"}
                  borderColor={"#CED2D6"}
                  py={6}
                  px={4}
                  display={"flex"}
                >
                  <Link href="/benefits-of-leasing">
                    <Text>
                      Benefits of Leasing vs. Owning Medical Office Buildings
                    </Text>
                  </Link>
                  <RightIcon />
                </ListItem>
              </List>
            </Box>
          </GridItem>
        </Grid>
      </Container>
    </Box>
        </>
  );
};

export default ArticleTwo;
